"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserLookup = void 0;
/* eslint-disable @typescript-eslint/no-unused-vars */
/* Package Imports */
var classnames_1 = __importDefault(require("classnames"));
var react_1 = __importStar(require("react"));
var react_autocomplete_1 = __importDefault(require("react-autocomplete"));
var react_toastify_1 = require("react-toastify");
/* Blast Imports */
var constants_1 = require("@app/shared/constants");
var log_1 = __importDefault(require("@app/shared/log"));
var utils_1 = require("@app/shared/utils");
var utils_2 = require("@server/shared/utils");
/* Imported CSS */
require("./UserLookup.scss");
var initialState = {
    isLoading: false,
    users: []
};
/**
 * Blast's User Lookup component, displays validated users as part of the upload form
 */
var UserLookup = /** @class */ (function (_super) {
    __extends(UserLookup, _super);
    function UserLookup() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = initialState;
        _this.WORKGROUP_RESTRICTION_ERROR = 'Packages being sent to a workgroup cannot have any other recipients.';
        /* Component Lifecycle Methods - end */
        /* Component Methods - begin */
        _this.checkQuotedEmail = function (email) {
            if (email.startsWith('"') && email.endsWith('"')) {
                return email.substring(1, email.length - 1);
            }
            if (email.startsWith('\'') && email.endsWith('\'')) {
                return email.substring(1, email.length - 1);
            }
            return email;
        };
        _this.handleBlur = function () { return __awaiter(_this, void 0, void 0, function () {
            var emails;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        emails = utils_1.splitEmails(this.props.inputValue);
                        return [4 /*yield*/, this.selectUser(emails, true, false)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        }); };
        _this.handleChange = function (event) {
            _this.props.onChange(event.target.value, !event.target.value /* event.target.value ? false : true */);
        };
        /**
         * Click event for outer container element. Set focus on input when any part of the component is clicked
         */
        _this.handleClick = function (event) {
            event.preventDefault();
            _this.inputEl.focus();
        };
        _this.handleKeyDown = function (event) { return __awaiter(_this, void 0, void 0, function () {
            var highlightedIndex;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!([constants_1.KEY_TAB_VALUE].indexOf(event.key) > -1)) return [3 /*break*/, 2];
                        highlightedIndex = this.inputEl.state.highlightedIndex;
                        if (!(highlightedIndex !== null)) return [3 /*break*/, 2];
                        event.preventDefault();
                        return [4 /*yield*/, this.selectUser([this.state.users[highlightedIndex].email], true, true)];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        }); };
        _this.handleKeyPress = function (event) { return __awaiter(_this, void 0, void 0, function () {
            var emails;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!([constants_1.KEY_COMMA_VALUE, constants_1.KEY_ENTER_VALUE, constants_1.KEY_SEMICOLON_VALUE].indexOf(event.key) > -1)) return [3 /*break*/, 2];
                        event.preventDefault();
                        emails = utils_1.splitEmails(this.props.inputValue);
                        return [4 /*yield*/, this.selectUser(emails, true, true)];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        }); };
        _this.handlePaste = function (event) { return __awaiter(_this, void 0, void 0, function () {
            var pastedText, emails;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        pastedText = event.clipboardData.getData('Text');
                        emails = utils_1.splitEmails(pastedText);
                        return [4 /*yield*/, this.selectUser(emails, true, true)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        }); };
        _this.handleRemove = function (email) {
            _this.props.onRemoveUser(email);
        };
        _this.handleSelect = function (email) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.selectUser([email], false, true)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        }); };
        _this.isUserSelected = function (email) {
            return _this.props.selectedUsers.map(function (u) { return u.email.toLowerCase(); }).indexOf(email.toLocaleLowerCase()) !== -1;
        };
        /**
         * Iterates an array of user email addresses and calls the onSelectUser property.
         * The second parameter specifies whether to validate the email address format
         */
        _this.selectUser = function (emails, validateEmail, focusInputAfterSelect) { return __awaiter(_this, void 0, void 0, function () {
            var erroredEmails, _i, emails_1, email, _a, containsInternalEmail_1;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!emails.length) {
                            return [2 /*return*/];
                        }
                        if (this.props.isWorkgroupPackage) {
                            this.props.onChange('', true);
                            this.toastError(constants_1.WORKGROUP_RESTRICTION, this.WORKGROUP_RESTRICTION_ERROR);
                            return [2 /*return*/];
                        }
                        this.setState({ isLoading: true });
                        erroredEmails = [];
                        _i = 0, emails_1 = emails;
                        _b.label = 1;
                    case 1:
                        if (!(_i < emails_1.length)) return [3 /*break*/, 6];
                        email = emails_1[_i];
                        if (!email) {
                            return [3 /*break*/, 5];
                        }
                        email = this.checkQuotedEmail(email);
                        log_1.default.debug(email + " is valid email: " + utils_2.isEmail(email));
                        // If the value is not a valid email format, exit the method
                        if (validateEmail && !utils_2.isEmail(email)) {
                            this.setState({ isLoading: false });
                            this.props.onChange(email, true);
                            return [2 /*return*/];
                        }
                        if (!validateEmail) {
                            if (utils_2.isWorkgroupByEmail(email) && this.props.selectedUsers.length > 0) {
                                this.setState({ isLoading: false });
                                this.props.onChange('', true);
                                this.toastError(constants_1.WORKGROUP_RESTRICTION, this.WORKGROUP_RESTRICTION_ERROR);
                                if (focusInputAfterSelect) {
                                    this.inputEl.focus();
                                }
                                return [2 /*return*/];
                            }
                        }
                        if (!!this.isUserSelected(email)) return [3 /*break*/, 5];
                        _b.label = 2;
                    case 2:
                        _b.trys.push([2, 4, , 5]);
                        return [4 /*yield*/, this.props.onSelectUser(email.trim())];
                    case 3:
                        _b.sent();
                        return [3 /*break*/, 5];
                    case 4:
                        _a = _b.sent();
                        log_1.default.debug("Add " + email + " to error list");
                        erroredEmails.push(email);
                        return [3 /*break*/, 5];
                    case 5:
                        _i++;
                        return [3 /*break*/, 1];
                    case 6:
                        this.setState({ isLoading: false });
                        this.props.onChange('', true);
                        if (focusInputAfterSelect) {
                            this.inputEl.focus();
                        }
                        if (!(erroredEmails.length > 0)) return [3 /*break*/, 8];
                        containsInternalEmail_1 = false;
                        return [4 /*yield*/, Promise.resolve(erroredEmails.map(function (e) {
                                if (utils_1.isInternalEmail(e)) {
                                    containsInternalEmail_1 = true;
                                }
                            }))];
                    case 7:
                        _b.sent();
                        react_toastify_1.toast.dismiss();
                        react_toastify_1.toast.error("Unable to send packages to " + erroredEmails.join(', ') + ". " +
                            ("" + (containsInternalEmail_1 ? 'Please verify that recipient(s) are an active Blast user.' : '')));
                        _b.label = 8;
                    case 8: return [2 /*return*/];
                }
            });
        }); };
        /**
         * Determine whether to show a user in the autocomplete suggestions list
         */
        _this.shouldUserBeDisplayed = function (user) {
            return !_this.isUserSelected(user.email);
        };
        _this.toastError = function (toastId, message) {
            if (react_toastify_1.toast.isActive(toastId)) {
                react_toastify_1.toast.update(toastId, {
                    render: message
                });
            }
            else {
                react_toastify_1.toast.error(message, {
                    toastId: toastId
                });
            }
        };
        return _this;
    }
    /* Component Lifecycle Methods - begin */
    UserLookup.getDerivedStateFromProps = function (nextProps, prevState) {
        return __assign(__assign({}, prevState), { users: nextProps.users });
    };
    /* Component Methods - end */
    UserLookup.prototype.render = function () {
        var _this = this;
        /* User Lookup constants */
        var containerClassName = classnames_1.default('user-lookup', 'tagsinput', 'field', 'is-grouped', 'is-grouped-multiline', 'input', { loading: this.state.isLoading });
        var inputStyle = { width: '100%' };
        return (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement("div", { className: containerClassName, onClick: this.handleClick },
                this.props.selectedUsers.map(function (u, i) { return react_1.default.createElement(UserTag, { key: u.email, user: u, onRemove: _this.handleRemove }); }),
                react_1.default.createElement(react_autocomplete_1.default, { ref: function (el) { return _this.inputEl = el; }, items: this.state.users, shouldItemRender: this.shouldUserBeDisplayed, getItemValue: function (item) { return item.email; }, renderItem: function (item, isHighlighted) {
                        return react_1.default.createElement("div", { key: item.email, className: classnames_1.default('lookup-entry', { hover: isHighlighted }) },
                            react_1.default.createElement("div", { className: classnames_1.default({ 'hasbro-user': item.isInternal }) },
                                react_1.default.createElement("p", null, item.email),
                                react_1.default.createElement("p", { className: "help has-text-weight-bold lookup-display-name" }, item.name)));
                    }, renderMenu: function (items, value, style) {
                        return react_1.default.createElement("div", { className: "user-lookup-menu", style: style }, items);
                    }, value: this.props.inputValue, onSelect: this.handleSelect, onChange: this.handleChange, inputProps: {
                        onKeyDown: this.handleKeyDown,
                        onKeyPress: this.handleKeyPress,
                        disabled: !!(this.state.isLoading || this.props.disabled),
                        placeholder: (this.props.disabled) ? 'No more recipients can be added' : '',
                        onPaste: this.handlePaste,
                        onBlur: this.handleBlur,
                        style: inputStyle
                    }, wrapperStyle: inputStyle }))));
    };
    return UserLookup;
}(react_1.Component));
exports.UserLookup = UserLookup;
var UserTag = function (props) {
    var user = props.user, onRemove = props.onRemove;
    var tagClass = user.isInternal ? 'internal-user' : 'external-user';
    return (react_1.default.createElement("div", { className: "control" },
        react_1.default.createElement("div", { className: "tags has-addons" },
            react_1.default.createElement("span", { className: classnames_1.default('tag', tagClass) },
                user.email,
                " ",
                react_1.default.createElement("button", { className: "delete is-small", onClick: function () { return onRemove(user.email); } })))));
};
